import useUiState from '~/composables/useUiState';
import { useUser } from '~/composables/_next/useUser';
export function useAuthenticatedAction() {
  var _useUser = useUser(),
    isAuthenticated = _useUser.isAuthenticated;
  var router = useRouter();
  var _useUiState = useUiState(),
    handleLoginNavigation = _useUiState.handleLoginNavigation;
  var _useNuxt2App = useNuxt2App(),
    app = _useNuxt2App.app;
  function navigateToOrLogin(_ref) {
    var nextRoutePath = _ref.nextRoutePath,
      previousRoutePath = _ref.previousRoutePath;
    var path = app.localePath(nextRoutePath);
    if (isAuthenticated.value) {
      return router.push(path);
    }
    handleLoginNavigation({
      nextRoutePath: nextRoutePath,
      previousRoutePath: previousRoutePath
    });
  }

  /**
   * Executes a specified action if the user is authenticated, otherwise opens the login modal.
   *
   * @param {Object} params - The parameters for the function.
   * @param {string} [params.nextRoutePath=null] - The target route to redirect to after login.
   * @param {string} [params.previousRoutePath=null] - The previous route before login.
   * @param {() => void} params.action - The function to execute if the user is authenticated.
   */
  function doActionOrLogin(_ref2) {
    var _ref2$nextRoutePath = _ref2.nextRoutePath,
      nextRoutePath = _ref2$nextRoutePath === void 0 ? null : _ref2$nextRoutePath,
      action = _ref2.action,
      _ref2$previousRoutePa = _ref2.previousRoutePath,
      previousRoutePath = _ref2$previousRoutePa === void 0 ? null : _ref2$previousRoutePa;
    if (isAuthenticated.value) {
      return action === null || action === void 0 ? void 0 : action();
    }
    handleLoginNavigation({
      nextRoutePath: nextRoutePath,
      loginAction: action,
      previousRoutePath: previousRoutePath
    });
  }
  return {
    navigateToOrLogin: navigateToOrLogin,
    doActionOrLogin: doActionOrLogin
  };
}